import { compactSmall, netFormat } from "../helpers/formatters"
import { RowType, TType } from "../types"

export const getTableCells = (t: TType) => [
  {
    name: "revenue",
    header: t("revenue.rev"),
    render: (row: RowType) => netFormat(row.revenue),
    sortBy: "revenue",
    align: "center",
    isColored: true,
  },
  {
    name: "growth",
    header: t("revenue.revgrowthpc"),
    render: (row: RowType) =>
      row.growth !== null ? compactSmall(row.growth) + "%" : "N/A",
    sortBy: "growth",
    align: "center",
  },
  {
    name: "margin",
    header: t("revenue.oibia.map"),
    render: (row: RowType) =>
      row.margin !== null ? compactSmall(row.margin) + "%" : "N/A",
    sortBy: "margin",
    align: "center",
  },
]
